// frontend/redux/slices/offerSlice.js
// Storefront side: holds the currently live offer (or null).
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";


export const fetchActiveOffer = createAsyncThunk("offer/fetchActive", async (_, { rejectWithValue }) => {
  try {
    const res = await axios.get(`${import.meta.env.VITE_BACKEND_URL}/api/offers/active`);
    return res.data; // { offer | null, serverTime }
  } catch (error) {
    return rejectWithValue(error.response?.data?.message || error.message || "Could not load offer");
  }
});

const offerSlice = createSlice({
  name: "offer",
  initialState: {
    offer: null,
    serverOffsetMs: 0, // serverTime - clientTime, so countdowns are right even if the phone clock is off
    loaded: false,
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchActiveOffer.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchActiveOffer.fulfilled, (state, action) => {
        state.loading = false;
        state.loaded = true;
        state.error = null;
        state.offer = action.payload?.offer || null;
        const server = Date.parse(action.payload?.serverTime);
        state.serverOffsetMs = Number.isFinite(server) ? server - Date.now() : 0;
      })
      .addCase(fetchActiveOffer.rejected, (state, action) => {
        // keep whatever we already know: a network blip must not make a live offer vanish
        state.loading = false;
        state.loaded = true;
        state.error = action.payload || "Could not load offer";
      });
  },
});


export default offerSlice.reducer;
